export const OpenSansBlack = {
  fontFamily: 'Open Sans',
  fontStyle: 'normal',
  fontWeight: 800,
  src: `
    url(${process.env.PUBLIC_URL}/fonts/OpenSans-ExtraBold.ttf)
  `,
}
export const OpenSansBlackItalic = {
  fontFamily: 'Open Sans',
  fontWeight: 800,
  fontStyle: 'italic',
  src: `
    url(${process.env.PUBLIC_URL}/fonts/OpenSans-ExtraBoldItalic.ttf))
  `,
}
export const OpenSansBold = {
  fontFamily: 'Open Sans',
  fontStyle: 'normal',
  fontWeight: 700,
  src: `
    url(${process.env.PUBLIC_URL}/fonts/OpenSans-Bold.ttf)
  `,
}
export const OpenSansBoldItalic = {
  fontFamily: 'Open Sans',
  fontWeight: 700,
  fontStyle: 'italic',
  src: `
    url(${process.env.PUBLIC_URL}/fonts/OpenSans-BoldItalic.ttf)
  `,
}
export const OpenSansSemiBold = {
  fontFamily: 'Open Sans',
  fontWeight: 600,
  fontStyle: 'normal',
  src: `
    url(${process.env.PUBLIC_URL}/fonts/OpenSans-SemiBold.ttf)
  `,
}
export const OpenSansSemiBoldItalic = {
  fontFamily: 'Open Sans',
  fontWeight: 600,
  fontStyle: 'italic',
  src: `
    url(${process.env.PUBLIC_URL}/fonts/OpenSans-SemiBoldItalic.ttf)
  `,
}

export const OpenSansRegular = {
  fontFamily: 'Open Sans',
  fontStyle: 'normal',
  fontWeight: 500,
  src: `
    url(${process.env.PUBLIC_URL}/fonts/OpenSans-Regular.ttf)
  `,
}
export const OpenSansRegularItalic = {
  fontFamily: 'Open Sans',
  fontWeight: 500,
  fontStyle: 'italic',
  src: `
    url(${process.env.PUBLIC_URL}/fonts/OpenSans-Italic.ttf)
  `,
}

export const OpenSansLight = {
  fontFamily: 'Open Sans',
  fontWeight: 400,
  fontStyle: 'normal',
  src: `
    url(${process.env.PUBLIC_URL}/fonts/OpenSans-Light.ttf)
  `,
}
export const OpenSansLightItalic = {
  fontFamily: 'Open Sans',
  fontWeight: 400,
  fontStyle: 'italic',
  src: `
    url(${process.env.PUBLIC_URL}/fonts/OpenSans-LightItalic.ttf
  `,
}
/* export const Open SansThin = {
  fontFamily: 'Open Sans',
  fontWeight: 300,
  fontStyle: 'normal',
  src: `
    url(${process.env.PUBLIC_URL}/fonts/Open Sans-Thin.ttf)
  `,
}
export const Open SansThinItalic = {
  fontFamily: 'Open Sans',
  fontWeight: 300,
  fontStyle: 'italic',
  src: `
    url(${process.env.PUBLIC_URL}/fonts/Open Sans-ThinItalic.ttf)
  `,
} */

export const fontFallbacks = [
  { '@font-face': OpenSansBlack },
  { '@font-face': OpenSansBlackItalic },
  { '@font-face': OpenSansBold },
  { '@font-face': OpenSansBoldItalic },
  { '@font-face': OpenSansLight },
  { '@font-face': OpenSansLightItalic },
  { '@font-face': OpenSansRegular },
  { '@font-face': OpenSansRegularItalic },
  { '@font-face': OpenSansSemiBold },
  { '@font-face': OpenSansSemiBoldItalic },
]
